import { Column, Entity, JoinColumn, JoinTable, ManyToOne } from 'typeorm';
import { OrderedModel } from '@nsk-app/models/orderedModel';
import { ContactInformation } from '@nsk-app/models/contactInformation';

@Entity({
  orderBy: {
    order: 'ASC'
  }
})
export class ContactElement extends OrderedModel {

  @Column()
  contact_information_id: number;

  @Column()
  caption: string;

  @Column()
  value: string;

  @Column({nullable: false, type: 'integer'})
  type: ContactElementType;

  @ManyToOne(type => ContactInformation, contact => contact.elements, {lazy: true})
  @JoinColumn({name: 'contact_information_id'})
  contact: Promise<ContactInformation>;
}

export enum ContactElementType {
  Address = 1,
  Phone = 2,
  Url = 3,
  Email = 4,
  Facebook = 5,
  Twitter = 6,
  Information = 7,
  Fax = 8
}
